"use strict";

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var srcToFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(src, fileName, imageResizingConfig) {
    var response, buffer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(src);

          case 2:
            response = _context.sent;

            if (!(response.ok && response.url)) {
              _context.next = 8;
              break;
            }

            _context.next = 6;
            return response.arrayBuffer();

          case 6:
            buffer = _context.sent;
            return _context.abrupt("return", new File([buffer], fileName, {
              type: imageResizingConfig.imageType
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function srcToFile(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var scaleImage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(img, fileName, imageResizingConfig) {
    var canvas, ctx, width, height, imageData, file;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            canvas = document.createElement('canvas');
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            width = img.width, height = img.height;

            if (width > height) {
              if (width > imageResizingConfig.maxWidth) {
                height *= imageResizingConfig.maxWidth / width;
                width = imageResizingConfig.maxWidth;
              }
            } else if (height > imageResizingConfig.maxHeight) {
              width *= imageResizingConfig.maxHeight / height;
              height = imageResizingConfig.maxHeight;
            }

            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            imageData = canvas.toDataURL(imageResizingConfig.imageType);
            _context2.next = 12;
            return srcToFile(imageData, fileName, imageResizingConfig);

          case 12:
            file = _context2.sent;
            return _context2.abrupt("return", file);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function scaleImage(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

exports.resizeImage = function (file) {
  var imageResizingConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    maxWidth: 1000,
    maxHeight: 1000,
    imageType: 'image/png'
  };
  return new Promise(function (resolve, reject) {
    var img = document.createElement('img');
    var reader = new FileReader();

    reader.onload = function (e) {
      img.src = e.target.result;
      img.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var scaledFile;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                scaledFile = scaleImage(img, file.name, imageResizingConfig);
                resolve(scaledFile);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

exports.fetchImage = function (url) {
  return new Promise(function (res) {
    var img = new Image();

    img.onload = function () {
      return res();
    };

    img.src = url;
  });
};

exports.fetchImages = function (urls) {
  return Promise.all(urls.map(exports.fetchImage));
};

var IMAGE_UTILS = {
  resizeImage: exports.resizeImage,
  fetchImage: exports.fetchImage,
  fetchImages: exports.fetchImages
};
exports.default = IMAGE_UTILS;